<template>
    <div>
        <el-card>
            <nav class="input" style="width: auto">
                <el-input v-model="search.keyword" size="medium" placeholder="优惠券名称、备注" />
            </nav>
            <nav class="input" style="width: auto">
               <el-select v-model="search.category" placeholder="优惠券类型" size="medium">
                        <el-option label="普通" :value="'or'" />
                        <el-option label="展商" :value="'ex'" />
                        <el-option label="个人" :value="'pe'" />
                    </el-select>
            </nav>
              
            <nav class="input" style="width: 150px">
                <el-button size="small" @click="reset">重置</el-button>
                <el-button type="primary" size="small" @click="subimt">{{ "搜索" }}</el-button>
            </nav>
            <nav class="input" style="width: auto">
                <el-button type="primary" size="small" @click="add">{{ "新建优惠券" }}</el-button>
            </nav>
          <nav class="input" style="width: auto">
            <el-button type="primary" size="small" @click="batchAdd">{{ "批量生成优惠券" }}</el-button>
          </nav>
        </el-card>
        <el-card style="margin-top: 10px">
            <el-table :data="list" style="width: 100%" border stripe :header-cell-style="rowClass">
                <el-table-column prop="id" label="ID" />
                <el-table-column prop="name" label="优惠券名称" />
                <el-table-column prop="discountType" label="优惠价格">
                    <template slot-scope="{ row }">
                        {{ row.discountType == 0 ? `-${row.discountValue}%` : `-${row.discountValue}元` }}
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="类型">
                    <template slot-scope="{ row }">
                        <div>{{ row.type == 0 ? "通用" : row.type == 1 ? "活动" : "VIP会员" }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="beginTime" label="有效时间">
                    <template slot-scope="{ row }">
                        {{ row.beginTime + " 至 " + row.endTime }}
                    </template>
                </el-table-column>
                 <el-table-column prop="status" label="优惠券类型">
                    <template slot-scope="{ row }">
                        <el-tag :type="row.categoryTxt ==  '个人' ? 'warning' :row.categoryTxt ==  '展商'?'info': 'primary'">{{ row.categoryTxt }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="{ row }">
                        <el-tag :type="row.status ? 'warning' : 'success'">{{ row.status ? "停止" : "启用" }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="使用/领取/总数">
                    <template slot-scope="{ row }">
                        <span class="click" @click="toReceive(row)">{{
                            `${row.usedNum}/${row.getNum}/${row.number}`
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="remask" label="备注">
                    <template slot-scope="{ row }">
                        <Remark :row="row" url="/admin/Coupon/editRemark"></Remark>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="二维码">
                    <template slot-scope="{ row }">
                        <el-image
                            style="width: 80px"
                            :src="baseurl + yu + row.sunCode"
                            :preview-src-list="[baseurl + yu + row.sunCode]"
                        />
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="{ row }">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            size="mini"
                            style="color: skyblue"
                            @click="editor(row)"
                            >编辑</el-button
                        >
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            size="mini"
                            style="color: red"
                            @click="deletes(row)"
                            >删除</el-button
                        >
                        <el-button
                            type="text"
                            icon="el-icon-s-promotion"
                            size="mini"
                            style="color: pink"
                            @click="shelves(row)"
                            >{{ row.status == 0 ? "停用" : "启用" }}</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                :current-page="search.page"
                background
                :page-sizes="[3, 5, 10, 15]"
                :page-size="search.pageSize"
                layout="total, prev, pager, next"
                :total="total"
                @current-change="handleCurrentChange"
            />
        </el-card>
      <pop ref="pop" title="批量生成优惠券" @toAudit="toAudit">
        <el-form :model="form" ref="form" :rules="rules" label-width="auto" :inline="false" size="normal">
          <el-form-item label="优惠券id">
            <el-col :span="8">
              <el-input v-model="batchForm.id"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="生成数量">
            <el-input-number v-model="batchForm.num" :step="1"></el-input-number>
          </el-form-item>
          <el-form-item label="总数">
            <el-input-number v-model="batchForm.couponNum" :step="1"></el-input-number>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="batchForm.desc"></el-input>
          </el-form-item>
          <el-form-item label="是否为PAGC">
            <el-radio-group v-model="batchForm.isPagc">
              <!-- <el-checkbox label="-1">全部</el-checkbox> -->
              <el-radio
                  :label="item.id"
                  v-for="(item, index) in [
                                    { id: 0, name: '否' },
                                    { id: 1, name: '是' },

                                ]"
                  :key="index"
              >
                <!--                              { id: 1, name: 'PAGC小程序' },-->
                {{ item.name }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-form>
      </pop>
    </div>
</template>

<script>
import list from "/src/mixin/list.js";
import { mapState } from "vuex";
import fuzzySelection from "@/components/fuzzySelection.vue";
import {awrap} from "bin-code-editor";
export default {
  components: {fuzzySelection},
    mixins: [list],
    data() {
        return {
            search: {
                keyword: "",
                page: 1,
                pageSize: 10,
                category:'or'
            },
            form: {
                keyword: "",
                page: 1,
                pageSize: 10,
            },
          batchForm:{
              id:'',
            num:'',
            couponNum:'',
            desc:'',
            isPagc:0,
          }
        };
    },
    created() {
        // this.getlist();
    },
    activated() {
        this.getlist();
    },
    methods: {
      toAudit(){
        this.$confirm('此操作将批量生成优惠券, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.batchCouponGenerate()
          this.$refs.pop.show=false


        }).catch(() => {
          this.$refs.pop.show=false
          this.batchForm=this.$options.data.call(this).batchForm
          this.$message({
            type: 'info',
            message: '已取消'
          });

        });
      },
      async batchCouponGenerate(){
        let {data} = await this.$http.post( '/admin/Coupon/batchCouponGenerate', {
          ...this.batchForm,
        })
        this.getlist()
        this.batchForm=this.$options.data.call(this).batchForm

      },
      batchAdd(){
this.$refs.pop.show = true;

      },
        add() {
            this.$router.push("/coupon_add");
        },
        toList(row) {
            this.$router.push({
                path: "/coupon_add",
                query: {
                    id: row.id,
                },
            });
        },
        toReceive(row) {
            this.$router.push({
                path: "/coupon_detail",
                query: {
                    id: row.id,
                },
            });
        },
        editor(row) {
            this.$router.push({
                path: "/coupon_add",
                query: {
                    id: row.id,
                },
            });
        },

        async deletes(row) {
            try {
                await this.$confirm("此操作将永久删除, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                });
                let { data: res } = await this.$http.delete("/admin/Coupon/delete", {
                    params: {
                        id: row.id,
                    },
                });
                if (res.errorCode == 200) {
                    this.$message.success(res.message);
                    if (this.total % 10 == 1) {
                        this.search.page--;
                    }
                    this.getlist();
                }
            } catch (error) {
                this.$message({
                    type: "info",
                    message: "已取消删除",
                });
            }
        },
        async shelves(row) {
            // console.log(row.status);
            const { data: res } = await this.$http.post("/admin/Coupon/updateStatus", {
                id: row.id,
                status: row.status ? 0 : 1,
            });
            if (res.errorCode == 200) {
                this.$message.success(res.message);
                this.getlist();
            }
        },
        handleCurrentChange(e) {
            this.search.page = e;
            this.form.page = e;
            this.getlist(this.form);
        },
        async getlist(val) {
            const form = val || this.search;
            let { data: res } = await this.$http.get("/admin/Coupon/getList", {
                params: {
                    ...form,
                },
            });
            this.list = res.data.list;
            this.total = res.data.totalCount;
        },
        subimt() {
            this.search.page = 1;
            this.form = {
                
                ...this.search,
            };
            this.getlist();
        },
    },
    computed: {
        ...mapState({
            btn_if: (state) => state.btn_if,
        }),
    },
};
</script>

<style lang="less" scoped>
.click {
    color: #0000ee;
    text-decoration: underline;
    cursor: pointer;
}
</style>
